import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M22.993 2.883A1 1 0 0 0 21 3v.999h-4V3l-.007-.117A1 1 0 0 0 15 3v.999h-4V3l-.007-.117A1 1 0 0 0 9 3v.999L7 4l-.15.005A2 2 0 0 0 5 6v19l.005.2A4 4 0 0 0 9 29h14l.2-.005A4 4 0 0 0 27 25V6l-.006-.15A2 2 0 0 0 25 4l-2-.001V3zM7 6l2-.001V7l.007.117A1 1 0 0 0 11 7V5.999h4V7l.007.117A1 1 0 0 0 17 7V5.999h4V7l.007.117A1 1 0 0 0 23 7V5.999L25 6v19l-.006.15A2 2 0 0 1 23 27H9l-.15-.006A2 2 0 0 1 7 25zm10.208 11.793a1 1 0 0 1 .082 1.32l-.083.094-3.505 3.5a1 1 0 0 1-1.32.082l-.095-.084-1.995-2a1 1 0 0 1 1.322-1.495l.094.083 1.288 1.291 2.797-2.792a1 1 0 0 1 1.415 0m.082-4.68a1 1 0 0 0-1.497-1.321l-2.797 2.792-1.288-1.291-.094-.083a1 1 0 0 0-1.322 1.495l1.995 2 .094.084a1 1 0 0 0 1.32-.082l3.506-3.5z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconToDos = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconToDos);
export default Memo;
